export default "__VITE_ASSET__78531ecd__"